<template>
  <!--导航菜单-->
  <el-menu
    ref="leftNavTeacher"
    :default-active="defaultActiveId"
    unique-opened
    text-color="#7C5A32"
    active-background-color="#c0e6ac"
    @open="handleOpenLeftNav"
  >
    <template v-for="item in leftNavList">
      <el-submenu :key="item.id" :index="item.id">
        <template slot="title" class="outter-title">
          <SvgIcon :icon-class="'add'" size="16px" class="inner-open" />
          <SvgIcon :icon-class="'remove'" size="16px" class="inner-close" />
          {{ item.themeName }}
        </template>
        <el-menu-item
          v-for="term in item.showBasicMeansList"
          :key="term.id"
          :index="term.id"
          @click="handleSelect(term)"
        >
          <span slot="title">{{ term.themeName }}</span>
        </el-menu-item>
      </el-submenu>
    </template>
  </el-menu>

</template>
<script>
// import Elmenuitem from '../ElmenuItem/ElmenuItem.vue'
// import { setTimeout } from 'timers'
export default {
  name: 'LeftNavTeachers',
  components: {
    // Elmenuitem
  },
  props: {
    leftNavList: {
      type: Array,
      default: null
    },
    defaultActiveId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      activeItem: ''
    }
  },

  mounted () {

  },
  methods: {
    handleOpenLeftNav(e) {
      this.activeItem = e
    },
    handleSelect(item) {
      this.$emit('select', item)
    },
    test(val) {
      console.log(val)
    },
    handleSelectLeftNav(e) {
      if (e.active === true) {
        this.activeItem = e
      }
    }
  }
}
</script>
<style scoped lang="scss">
  /deep/[class*=" el-icon-"], [class^=el-icon-] {
      display: none !important;
    }
    .el-submenu.is-opened > .el-submenu__title .inner-open{
      display: none;
    }
    .el-submenu.is-opened > .el-submenu__title .inner-close{
      display:inline;
    }
    .el-submenu > .el-submenu__title .inner-close{
      display: none;
    }
    .inner-close{
      margin-right: 5px;
    }
    .inner-open{
      margin-right:5px
    }
    .el-menu{
      border-right: none;
    }
    .el-submenu .el-menu-item{
      padding-right: 0px!important;
    }
    .choosenItem{

      border-right: solid 5px #84cb5e;
      color: #9ed682!important;
      background-color: #f0f9ec!important;
      position: relative;
      background-clip: content-box;
    }
    .el-menu-item.is-active{
      border-right: solid 5px #84cb5e;
      color: #9ed682!important;
      background-color: #f0f9ec!important;
      position: relative;
      background-clip: content-box;
    }
    .el-menu-item.is-active::before{
      background-color: #f0f9ec!important;
      position: absolute;
      content: '';
      width: 90%;
      height: 100%;
      z-index: -1;
    }
    .choosenItem::before{
      background-color: #f0f9ec!important;
      position: absolute;
      content: '';
      width: 90%;
      height: 100%;
      z-index: -1;
    }
    .el-submenu .el-menu-item{
      position: relative;
    }
    .el-menu-item:hover, .el-menu-item:focus{
        background-color:none !important;
    }
    .el-submenu .el-menu-item{
      position: relative;
      text{
        padding-left: 10px;
      }
      height: 30px  !important;
      line-height: 30px !important;
    }
    .el-submenu .el-menu-item::after{
      position: absolute;
      content: '';
      height: 100%;
      // background-color: #A5835B;
      background: linear-gradient(to top, #f0f9ec, #A5835B);
      background-size: 60% 10%;
      background-repeat: repeat-y;
      width: 3px;
      background-color: res;
      left: 30px !important;
      z-index: 2;
    }
    
    /deep/.el-submenu__title{
      height: 30px !important;
      line-height:30px !important;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
</style>

